import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import TreatmentsList from "@/pages/TreatmentsList";
import TreatmentDetail from "@/pages/TreatmentDetail";
import ChooseYourTreatment from "@/pages/ChooseYourTreatment";
import HowItWorks from "@/pages/HowItWorks";
import Pricing from "@/pages/Pricing";
import Safety from "@/pages/WhatToExpect";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import WhyMelbi from "@/pages/WhyMelbi";
import TrustYourSource from "@/pages/TrustYourSource";
import ServiceAreas from "@/pages/ServiceAreas";
import MedicalDisclosures from "@/pages/MedicalDisclosures";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Save10 from "@/pages/Save10";
import Partner from "@/pages/Partner";
import { Toaster } from "@/components/ui/sonner";

export function AppRoutes() {
  return (
    <Routes>
          <Route path="/save10" element={<Save10 />} />
          <Route path="/partners/:slug" element={<Partner />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/treatments" element={<TreatmentsList />} />
            <Route path="/treatments/nad-nasal-spray" element={<Navigate to="/treatments/vitality" replace />} />
            <Route path="/treatments/:slug" element={<TreatmentDetail />} />
            <Route path="/choose-your-treatment" element={<ChooseYourTreatment />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/what-to-expect" element={<Safety />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-melbi" element={<WhyMelbi />} />
            <Route path="/trust-your-source" element={<TrustYourSource />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/medical-disclosures" element={<MedicalDisclosures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/:slug" element={<Legal />} />
          </Route>
        </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
